// libraries
import clsx from 'clsx'

// components
import Image, { ImageProps } from '/react4xp/components/Image'
import Section from '/react4xp/components/Section'

// types
interface ImageBlockProps {
    className?: string
    isAnimated?: boolean
    image?: ImageProps
    caption?: string
}

// css
import './index.scss'

export default function ImageBlock({
    className,
    isAnimated,
    image,
    caption
}: ImageBlockProps) {
    return (
        <Section className={clsx(
            'image-block-component',
            className
        )}>
			<div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                <div className='image-block-component__wrapper'>

                    <Image
                        src={image?.src}
                        srcSmall={image?.srcSmall}
                        srcMedium={image?.srcMedium}
                        srcLarge={image?.srcLarge}
                        alt={image?.alt || ''}
                        sizes='100vw'
                        lazyLoad
                        className='image-block-component__image'
                    />

                    {caption && (
                        <p className='image-block-component__caption'>
                            {caption}
                        </p>
                    )}

                </div>
            </div>
        </Section>
    )
}